import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
} from "mdbreact";
import { toast, ToastContainer } from "react-toastify";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditExpensesMain from "./AddEditExpensesMain";

const ExpensesMain = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);
  const [showPreloader, setPreloader] = useState("normal");
  const [strTransactions, setTransactions] = useState("");
  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = (transtype) => {
    setRows([]);

    showAddEdit(!modalAddEdit);

    loadData();
  };

  const toastId = React.useRef(null);

  const notify = (message) => {
    toastId.current = toast.info(message);
  };

  const [bRefresh, setRefresh] = useState(false);

  const refreshGrid = (message) => {
    setRows([]);
    setRefresh(!bRefresh);

    loadData();
    notify(message);
  };

  const showResult = (message) => {
    setRefresh(!bRefresh);

    setRows([]);

    // loadData();

    loadData();

    toast.info(message, {
      closeButton: false,
    });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(
      props.apiServer + "/expensesmainlist?keyword=" + strTransactions,
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function ShowDeleted() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("deleted");
    loadData();
  }

  function ShowReturns() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("returns");
    loadData();
  }

  function ShowExpensesMain() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("ExpensesMain");
    loadData();
  }

  function ShowAll() {
    setPreloader("normal");
    setTransactions("");
    loadData();
  }
  const useMountEffect = (functionName) => useEffect(functionName, []);

  // useMountEffect(checkAdminAccess);

  useEffect(() => {
    loadData();
  }, [strTransactions]);

  return (
    <React.Fragment>
      <MDBRow className="pt-5">
        <MDBCol md="12">
          {/* <MDBBtn className="blue-gradient waves-light" title="Refresh" onClick={()=>{ShowAll()}}>
                  <MDBIcon icon="check-double" className="pr-2" />
                 All
                </MDBBtn> */}
          <MDBBtn
            color="primary"
            title="Refresh"
            onClick={() => {
              ShowExpensesMain();
            }}
          >
            <MDBIcon icon="cash-register" className="pr-2" />
            Expenses
          </MDBBtn>

          <MDBBtn
            color="danger"
            title="Refresh"
            onClick={() => {
              ShowDeleted();
            }}
          >
            <MDBIcon icon="trash" className="pr-2" />
            Deleted
          </MDBBtn>
        </MDBCol>
      </MDBRow>
      <MDBRow className="mt-4 pt-4">
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <MDBRow>
              <MDBCol md="4"></MDBCol>
              <MDBCol md="4" className="text-center">
                <br />
                <img
                  src={props.deployURL + "/loading.gif"}
                  style={{ width: "300px", textAlign: "center" }}
                  alt="loading"
                />
                <br />
              </MDBCol>
              <MDBCol md="4"></MDBCol>
            </MDBRow>
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="8">
                  <h6
                    style={{ fontFamily: "Montserrat", fontWeight: "400" }}
                    className="display-5 blue-grey-text ml-1"
                  >
                    {" "}
                    EXPENSES
                  </h6>
                </MDBCol>
                <MDBCol md="4">
                  <a href="#" className="float-right" onClick={toggleAddEdit}>
                    {" "}
                    <MDBIcon
                      icon="plus"
                      size="2x"
                      className="blue-text"
                      title="RECEIVE NEW ITEMS"
                    />
                  </a>
                </MDBCol>
              </MDBRow>

              <MaterialTable
                title=""
                columns={[
                  { title: "Transaction Date", field: "transactiondatetext" },

                  { title: "code", field: "code", hidden: true },
                  { title: "Expenses", field: "expense" },
                  { title: "Remarks", field: "remarks" },
                  { title: "Amount", field: "amount" },
                ]}
                data={rows}
                options={{
                  search: true,
                  actionsColumnIndex: -1,
                }}
                detailPanel={[
                  {
                    icon: () => (
                      <MDBIcon icon="industry" className="blue-text" />
                    ),
                    openIcon: () => (
                      <MDBIcon
                        icon="chevron-circle-down"
                        className="red-text"
                      />
                    ),
                    tooltip: "Expenses Main",
                    render: (rowData) => {
                      return (
                        <MDBContainer
                          className="ml-0"
                          style={{ minWidth: "800px" }}
                        >
                          <MDBCardHeader className="cloudy-knoxville-gradient">
                            <span className="font-weight-bold">
                              {" "}
                              Sales Main
                            </span>
                          </MDBCardHeader>
                          <MDBCardBody>
                            <AddEditExpensesMain
                              deployURL={props.deployURL}
                              apiServer={props.apiServer}
                              code={rowData.code}
                              apiServerHybrid={props.apiServerHybrid}
                              toggleModal={toggleAddEdit}
                              refreshGrid={refreshGrid}
                              showResult={showResult}
                            ></AddEditExpensesMain>
                          </MDBCardBody>
                          <MDBCardFooter></MDBCardFooter>
                        </MDBContainer>
                      );
                    },
                  },
                ]}
              />
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      <MDBModal
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <b>Add Expenses</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditExpensesMain
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              code="new"
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleAddEdit}
              refreshGrid={refreshGrid}
            ></AddEditExpensesMain>
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>

      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={2000}
      />
      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default ExpensesMain;
